<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <div class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd">
            <label for class="weui-label">仓库类型</label>
          </div>
          <div class="weui-cell__bd">
            <select class="weui-select" v-model="form.wh_type" placeholder="请选择">
              <option>良品仓</option>
              <option>不良品仓</option>
            </select>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">仓库名称</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.wh_description"
              placeholder="请输入仓库名称"
            />
          </div>
        </div>
        <div class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd">
            <label for class="weui-label">物料类型</label>
          </div>
          <div class="weui-cell__bd">
            <select class="weui-select" v-model="form.wh_product_type" placeholder="请选择">
              <option>成品</option>
              <option>半成品</option>
              <option>原材料</option>
            </select>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">仓库地址</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.wh_address"
              placeholder="请输入仓库地址"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">保存</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/document/warehouse",
      form: {
        wh_type: "良品仓",
        wh_product_type: "成品"
      }
    };
  },
  methods: {
    save() {
      var me = this,
        main = me.form;
      if (!main.wh_description) {
        me.$weui.topTips("请填写仓库名称", 2000);
      } else {
        me.f_save();
      }
    }
  }
};
</script>